// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-item-row {
  --row-bg: #eef3f7;
  --text: #1f1f1f;
  --muted: #6b6b6b;
  --btn: #1f1f1f;

  display: flex;
  align-items: center;

  gap: 12px;

  min-height: 42px;
  padding: 0 12px;

  background: var(--row-bg);
  border-radius: 6px;

  box-shadow: 0 1px 0 rgba(0,0,0,0.04) inset;
}

.stock-item-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.col-name         { flex: 4 1 0; }
.col-size         { flex: 2 1 0; }
.col-state        { flex: 2 1 0; }
.col-amount       { flex: 2 1 0; } 
.col-p            { flex: 2 1 0; }
.col-collection   { flex: 2 1 0; }

.stock-item-label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.stock-item-control {
  width: 100%;
  min-width: 0;

  border: 0;
  background: transparent;
  color: var(--text);

  font: inherit;
  line-height: 1;
  padding: 10px 6px;

  outline: none;
  font-size: 17px;
}

.stock-item-control[type="number"],
.stock-item-control:not([type]) {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.stock-item-control::-webkit-inner-spin-button,
.stock-item-control::-webkit-outer-spin-button {
  appearance: none;
}

.controls button {
  flex: 1;
  width: 40px;
  font-size: 15px;
  padding:4px;
  border: 0px solid #ccc;
  background: #f5f5f5;
  cursor: pointer;
  color: #6b6b6b;
}

.controls button:not(:disabled):hover {
  background: #e0e0e0;
}

.controls button:not(:disabled):active {
  background: #d0d0d0;
}

.controls button:disabled {
  background: #f0f0f0;
  color: #b5b5b5;
  border-color: #e0e0e0;
  cursor: not-allowed;
}

select.stock-item-control {
  padding-right: 18px;
  background-image: linear-gradient(45deg, transparent 50%, var(--muted) 50%),
    linear-gradient(135deg, var(--muted) 50%, transparent 50%);
  background-position: calc(100% - 12px) 52%, calc(100% - 7px) 52%;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  line-height: 22px;
}

.stock-item-remove,
.stock-item-plus {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex: 0 0 40px; 
  width: 36px;
  height: 36px;

  border: 0;
  background: transparent;
  color: var(--btn);

  border-radius: 6px;
  cursor: pointer;
}

input[type="number"].stock-item-control {
  text-align: right;
}

.stock-item-remove:hover,
.stock-item-plus:hover {
  background: rgba(0, 0, 0, 0.06);
}

.stock-item-remove:active,
.stock-item-plus:active {
  background: rgba(0, 0, 0, 0.10);
}

.stock-item-control:focus-visible,
.stock-item-remove:focus-visible,
.stock-item-plus:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.35);
  outline-offset: 2px;
}

.stock-item-row[aria-disabled="true"],
.stock-item-row .stock-item-control:disabled,
.stock-item-row button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.stock-item-field:first-of-type .stock-item-control {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.searchable-select {
  position: relative;
  width: 100%;
}

.searchable-select-menu {
  position: absolute;
  z-index: 50;
  left: 0;
  right: 0;
  margin-top: 1px;
  border: 1px solid rgba(0,0,0,0.6);
  background: white;
  max-height: 220px;
  overflow: auto;
}

.searchable-select-item {
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 17px;
}

.searchable-select-item:hover,
.searchable-select-item.is-selected {
  background: rgb(0, 120, 215);
  color: #ffff;
}

.searchable-select-empty {
  padding: 10px;
  opacity: 0.7;
}

.stock-item-control::placeholder {
  color: #000;
  opacity: 1;
}

.stock-item-select-with-plus {
  display: flex;
  gap: 4px;
  align-items: center;
  width: 100%;
}

.stock-item-select-with-plus .stock-item-control {
  flex: 1 1 auto;
  width: 100%;
}

.stock-item-plus-btn {
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #f5f5f5;
  cursor: pointer;
  font-weight: 600;
  line-height: 1;
  padding: 0;
}

.stock-item-dialog {
  position: absolute;
  /* adjust as needed depending on layout */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 50;
}

.stock-item-dialog-content {
  background: #fff;
  border: 1px solid #ccc;
  padding: 8px 10px;
  border-radius: 4px;
  min-width: 220px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.stock-item-dialog-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.stock-item-dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 6px;
}

.stock-item-dialog-close,
.stock-item-dialog-confirm {
  padding: 3px 8px;
  font-size: 12px;
  cursor: pointer;
  background: #c44a4a;
  color: #ffffff;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/web/component/ItemRow/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,aAAa;EACb,mBAAmB;;EAEnB,SAAS;;EAET,gBAAgB;EAChB,eAAe;;EAEf,yBAAyB;EACzB,kBAAkB;;EAElB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA,oBAAoB,WAAW,EAAE;AACjC,oBAAoB,WAAW,EAAE;AACjC,oBAAoB,WAAW,EAAE;AACjC,oBAAoB,WAAW,EAAE;AACjC,oBAAoB,WAAW,EAAE;AACjC,oBAAoB,WAAW,EAAE;;AAEjC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,SAAS;EACT,uBAAuB;EACvB,kBAAkB;;EAElB,aAAa;EACb,cAAc;EACd,iBAAiB;;EAEjB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB;8DAC4D;EAC5D,gEAAgE;EAChE,iCAAiC;EACjC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,cAAc;EACd,WAAW;EACX,YAAY;;EAEZ,SAAS;EACT,uBAAuB;EACvB,iBAAiB;;EAEjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;EAGE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd","sourcesContent":[".stock-item-row {\r\n  --row-bg: #eef3f7;\r\n  --text: #1f1f1f;\r\n  --muted: #6b6b6b;\r\n  --btn: #1f1f1f;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  gap: 12px;\r\n\r\n  min-height: 42px;\r\n  padding: 0 12px;\r\n\r\n  background: var(--row-bg);\r\n  border-radius: 6px;\r\n\r\n  box-shadow: 0 1px 0 rgba(0,0,0,0.04) inset;\r\n}\r\n\r\n.stock-item-field {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.col-name         { flex: 4 1 0; }\r\n.col-size         { flex: 2 1 0; }\r\n.col-state        { flex: 2 1 0; }\r\n.col-amount       { flex: 2 1 0; } \r\n.col-p            { flex: 2 1 0; }\r\n.col-collection   { flex: 2 1 0; }\r\n\r\n.stock-item-label {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n.stock-item-control {\r\n  width: 100%;\r\n  min-width: 0;\r\n\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--text);\r\n\r\n  font: inherit;\r\n  line-height: 1;\r\n  padding: 10px 6px;\r\n\r\n  outline: none;\r\n  font-size: 17px;\r\n}\r\n\r\n.stock-item-control[type=\"number\"],\r\n.stock-item-control:not([type]) {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n}\r\n\r\n.stock-item-control::-webkit-inner-spin-button,\r\n.stock-item-control::-webkit-outer-spin-button {\r\n  appearance: none;\r\n}\r\n\r\n.controls button {\r\n  flex: 1;\r\n  width: 40px;\r\n  font-size: 15px;\r\n  padding:4px;\r\n  border: 0px solid #ccc;\r\n  background: #f5f5f5;\r\n  cursor: pointer;\r\n  color: #6b6b6b;\r\n}\r\n\r\n.controls button:not(:disabled):hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.controls button:not(:disabled):active {\r\n  background: #d0d0d0;\r\n}\r\n\r\n.controls button:disabled {\r\n  background: #f0f0f0;\r\n  color: #b5b5b5;\r\n  border-color: #e0e0e0;\r\n  cursor: not-allowed;\r\n}\r\n\r\nselect.stock-item-control {\r\n  padding-right: 18px;\r\n  background-image: linear-gradient(45deg, transparent 50%, var(--muted) 50%),\r\n    linear-gradient(135deg, var(--muted) 50%, transparent 50%);\r\n  background-position: calc(100% - 12px) 52%, calc(100% - 7px) 52%;\r\n  background-size: 5px 5px, 5px 5px;\r\n  background-repeat: no-repeat;\r\n  line-height: 22px;\r\n}\r\n\r\n.stock-item-remove,\r\n.stock-item-plus {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  flex: 0 0 40px; \r\n  width: 36px;\r\n  height: 36px;\r\n\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--btn);\r\n\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\ninput[type=\"number\"].stock-item-control {\r\n  text-align: right;\r\n}\r\n\r\n.stock-item-remove:hover,\r\n.stock-item-plus:hover {\r\n  background: rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.stock-item-remove:active,\r\n.stock-item-plus:active {\r\n  background: rgba(0, 0, 0, 0.10);\r\n}\r\n\r\n.stock-item-control:focus-visible,\r\n.stock-item-remove:focus-visible,\r\n.stock-item-plus:focus-visible {\r\n  outline: 2px solid rgba(0, 0, 0, 0.35);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.stock-item-row[aria-disabled=\"true\"],\r\n.stock-item-row .stock-item-control:disabled,\r\n.stock-item-row button:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.stock-item-field:first-of-type .stock-item-control {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.searchable-select {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.searchable-select-menu {\r\n  position: absolute;\r\n  z-index: 50;\r\n  left: 0;\r\n  right: 0;\r\n  margin-top: 1px;\r\n  border: 1px solid rgba(0,0,0,0.6);\r\n  background: white;\r\n  max-height: 220px;\r\n  overflow: auto;\r\n}\r\n\r\n.searchable-select-item {\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 8px 10px;\r\n  background: transparent;\r\n  border: 0;\r\n  cursor: pointer;\r\n  font-size: 17px;\r\n}\r\n\r\n.searchable-select-item:hover,\r\n.searchable-select-item.is-selected {\r\n  background: rgb(0, 120, 215);\r\n  color: #ffff;\r\n}\r\n\r\n.searchable-select-empty {\r\n  padding: 10px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.stock-item-control::placeholder {\r\n  color: #000;\r\n  opacity: 1;\r\n}\r\n\r\n.stock-item-select-with-plus {\r\n  display: flex;\r\n  gap: 4px;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.stock-item-select-with-plus .stock-item-control {\r\n  flex: 1 1 auto;\r\n  width: 100%;\r\n}\r\n\r\n.stock-item-plus-btn {\r\n  flex: 0 0 auto;\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n  background: #f5f5f5;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  padding: 0;\r\n}\r\n\r\n.stock-item-dialog {\r\n  position: absolute;\r\n  /* adjust as needed depending on layout */\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 50;\r\n}\r\n\r\n.stock-item-dialog-content {\r\n  background: #fff;\r\n  border: 1px solid #ccc;\r\n  padding: 8px 10px;\r\n  border-radius: 4px;\r\n  min-width: 220px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\r\n}\r\n\r\n.stock-item-dialog-title {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.stock-item-dialog-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n  margin-top: 6px;\r\n}\r\n\r\n.stock-item-dialog-close,\r\n.stock-item-dialog-confirm {\r\n  padding: 3px 8px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  background: #c44a4a;\r\n  color: #ffffff;\r\n  border: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
